import { useAuth0 } from '@auth0/auth0-react';
import { getRedirectUri } from '../../components/providers/Auth0Provider';
import { useCallback } from 'react';

function openInBrowser(url) {
  if (window.cordova && window.SafariViewController) {
    window.SafariViewController.isAvailable(function (available) {
      if (available) {
        window.SafariViewController.show(
          { url: url },
          function (_result) {},
          function (msg) {
            console.log('KO: ' + JSON.stringify(msg));
          },
        );
      } else {
        window.open(url, '_system');
      }
    });
  } else {
    window.open(url, '_system');
  }
}

function backupAuth0Transactions() {
  Object.keys(sessionStorage)
    .filter((k) => k.startsWith('a0.spajs.txs.'))
    .forEach((k) => localStorage.setItem(k, sessionStorage.getItem(k)));
}

function restoreAuth0Transactions() {
  Object.keys(localStorage)
    .filter((k) => k.startsWith('a0.spajs.txs.'))
    .forEach((k) => {
      sessionStorage.setItem(k, localStorage.getItem(k));
      localStorage.removeItem(k);
    });
}

async function openUrl(url) {
  try {
    if (window.cordova) backupAuth0Transactions();
    if (window.cordova && window.plugins && window.plugins.ASWebAuthSession) {
      const packageId = process.env.REACT_APP_PACKAGE_NAME || 'com.ackertinc.pipeline';
      window.plugins.ASWebAuthSession.start(
        packageId,
        url,
        function (callbackUrl) {
          if (window.handleOpenURL) window.handleOpenURL(callbackUrl);
        },
        function (err) {
          console.log('ASWebAuthSession error:', JSON.stringify(err));
        },
      );
    } else {
      openInBrowser(url);
    }
  } catch (err) {
    console.log(err);
  }
}

export { restoreAuth0Transactions };

export const useLoginWithRedirect = () => {
  const { loginWithRedirect } = useAuth0();

  return useCallback(
    async () =>
      await loginWithRedirect({
        connection: 'Jenner',
        prompt: 'login',
        authorizationParams: { redirect_uri: getRedirectUri() },
        ...(window.cordova ? { openUrl } : {}),
      }),
    [loginWithRedirect],
  );
};

export const useLogout = () => {
  const { logout } = useAuth0();

  const doLogout = useCallback(async () => {
    await logout({
      logoutParams: {
        returnTo: getRedirectUri(),
      },
      openUrl,
    });
  }, [logout]);

  return doLogout;
};
